import { FlowListItem } from '~src/flow/serverApi/types/Flow';
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IPublishedConnection } from '~src/publishedConnection/serverApi/types/IPublishedConnection';
import { INamedItem, ITypedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';
import { IWorkbook } from '~src/workbook/ServerApi/types/IWorkbook';

import { IRecent } from '../types/IRecent';

export interface IGetDetailedRecentsResult extends IGetItemsResult {
  publishedConnections?: IPublishedConnection[];
  publishedConnectionFavorites?: string[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  recents?: IRecent[];
  users?: IUser[];
  views?: IView[];
  workbooks?: IWorkbook[];
  viewFavorites?: string[];
  flows?: FlowListItem[];
  flowFavorites?: string[];
}

export class GetDetailedRecentsRequest extends Request<IGetItemsParams, IGetDetailedRecentsResult> {
  constructor(params: IGetItemsParams) {
    super('getDetailedRecents', params);
  }
}
